import { useNotifications } from './NotificationProvider';
import { MessagingPanel } from './MessagingPanel';

/**
 * Mounts the messaging drawer exactly once, globally, driven by the notification context. The bell
 * lives in the nav (and there are two instances, desktop + mobile); keeping the panel here means it
 * can never be rendered twice. Renders nothing until a conversation is opened.
 */
export function MessagingMount() {
  const { panel, composeRef, clearComposeRef, closeMessaging } = useNotifications();
  return panel ? (
    <MessagingPanel
      selection={panel}
      composeRef={composeRef}
      onClearRef={clearComposeRef}
      onClose={closeMessaging}
    />
  ) : null;
}
